import React from "react";
var View = function View(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.84 19.5c-4.33 0-8.63-3-11.22-5.88a2.42 2.42 0 010-3.24C3.21 7.54 7.51 4.5 11.86 4.5h.3c4.33 0 8.63 3 11.22 5.88a2.41 2.41 0 010 3.23c-2.59 2.85-6.9 5.89-11.24 5.89h-.3zm0-13.5C8 6 4.1 8.78 1.73 11.39a.92.92 0 000 1.22C4.1 15.21 8 18 11.85 18h.27c3.87 0 7.78-2.79 10.15-5.39a.91.91 0 000-1.22C19.9 8.78 16 6 12.14 6h-.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5a4.51 4.51 0 113.18-1.32A4.47 4.47 0 0112 16.5zM12 9a3 3 0 102.12.87A3 3 0 0012 9z"
  }));
};
View.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
import createIconComponent from '../createIconComponent';
export const ViewIcon = createIconComponent(View, 'View');